import HeroKineticSection from "../components/HeroKineticSection";
import EditorialMarquee from "../components/EditorialMarquee";
import Seo from "../components/Seo";
import ProblemaSection from "../sections/ProblemaSection";
import { ImpresaPartnerSection, CompensiSection } from "../sections/ImpresaCompensiSection";
import ObiettiviSection from "../sections/ObiettiviSection";
import MetodoSection from "../sections/MetodoSection";
import ProtocolliSection from "../sections/ProtocolliSection";
import PiattaformaSection from "../sections/PiattaformaSection";
import AssistenteSection from "../sections/AssistenteSection";
import { ControlloSection, EcosistemaSection, PercheSection } from "../sections/EcosistemaSection";
import PartnerSection from "../sections/PartnerSection";
import ChiSiamoSection from "../sections/ChiSiamoSection";
import { ContattiSection, FinalCtaSection } from "../sections/ContattiSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Seo
        title="A.C. HUB — Real Estate Advisory | Consulenza Immobiliare di Parte"
        description="Consulenza immobiliare di parte: referente unico per vendere, comprare, investire o ristrutturare. Partner selezionati con te, portale digitale riservato."
        path="/"
      />
      <HeroKineticSection />
      <EditorialMarquee />
      <ProblemaSection />
      <ObiettiviSection />
      <MetodoSection />
      <ProtocolliSection />
      <ImpresaPartnerSection />
      <CompensiSection />
      <PiattaformaSection />
      <AssistenteSection />
      <EcosistemaSection />
      <PartnerSection />
      <ControlloSection />
      <PercheSection />
      <ChiSiamoSection />
      <ContattiSection />
      <FinalCtaSection />
    </main>
  );
}
